import React from "react";
import Nav from "@/components/Nav";
import Footer from "@/components/Footer";

export default function Layout({ children }) {
  return (
    <div className="min-h-screen flex flex-col bg-[#F9F8F6]">
      <Nav />
      <main className="flex-1">{children}</main>
      <Footer />
    </div>
  );
}
